<div fxLayout="row" fxLayoutAlign="center center">
    <div class="initiate-password-reset-form">
            <div *ngIf="state === 'reset' || state === 'loading'">
                <div class="header">
                    <circle-al-logo></circle-al-logo>
                    <div class="title"><h2>Reset Your Password</h2></div>
                </div>
                <div>
                </div>
                <div class="reset-text">
                    Alert Logic provides a single log in for Cloud Defender and Cloud Insight. Change your password to use the same credentials for both products.
                </div>
                <mat-form-field class="mat-block">
                    <input matInput [(ngModel)]="emailAddress" name="emailAddress" placeholder="Email Address" class="textarea-email testing-email-input"
                        pattern="^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$" required #email="ngModel" (keydown)="onKeyDown($event)"/>
                    <mat-error [hidden]="email.valid || email.pristine" class="testing-email-error">You must enter a valid email address in the following format: <i>john@doe.com</i>.</mat-error>
                </mat-form-field>
                <button mat-raised-button color="primary" class="button-width" [disabled]="!email.valid" (click)="onResetPassword()">RESET PASSWORD</button>
            </div>
            <al-loading-spinner *ngIf="state === 'loading'"></al-loading-spinner>
            <div *ngIf="state === 'sent'">
                <div class="header">
                    <circle-success></circle-success>
                    <div class="title"><h2>Password Email Sent!</h2></div>
                </div>
                <div class="reset-text">
                    Alert Logic just sent an email to you.
                    <p>
                    Open the email, and follow the instructions to reset your password.
                </div>
                <button mat-raised-button color="primary" class="button-width" (click)="onReturnToLogin()">BACK TO LOGIN SCREEN</button>
            </div>
            <div *ngIf="errorMessage">
                <mat-card>
                    <mat-card-title-group>
                        <mat-card-content>{{errorMessage}}</mat-card-content>
                        <i (click)="closeMessageError()" class="material-icons">cancel</i>
                    </mat-card-title-group>
                </mat-card>
            </div>
        </div>
</div>
